import Helper from "./Helper";
import Swiper from "../lib/swiper";

class SliderHandler {
  constructor(config = {}) {
    const {
      sliderType,
      outerWrapperSelector,
      sliderContainerSelector,
      sliderPaginationselector,
      sliderPrevSelector,
      sliderNextSelector,
      sliderBreakpoint,
    } = config;
    this.sliderType = sliderType;
    this.outerWrapperSelector = outerWrapperSelector;
    this.sliderContainerSelector =
      sliderContainerSelector || ".swiper-container";
    this.sliderPaginationselector =
      sliderPaginationselector || ".swiper-pagination";
    this.sliderPrevSelector = sliderPrevSelector || ".swiper-button-prev";
    this.sliderNextSelector = sliderNextSelector || ".swiper-button-next";
    this.sliderBreakpoint = sliderBreakpoint || 768;

    this.sliders = document.querySelectorAll(this.outerWrapperSelector);
    this.slidersArray = Array.prototype.slice.call(this.sliders);

    this.currentScreenWidth = window.innerWidth;
    this.previousScreenWidth = window.innerWidth;
    this.sliderIsInitiated = false;
    this.currentlyDesktop = "";
    this.swiperInstances = [];

    if (this.sliders) {
      this.bindEvents();
    }
  }

  bindEvents() {
    this.initSwipersDesktop();
    /*
    if (this.currentScreenWidth < this.sliderBreakpoint) {
      this.currentlyDesktop = false;
      this.initSwipersMobile();
    } else {
      this.currentlyDesktop = true;
      this.initSwipersDesktop();
    }

    window.addEventListener("resize", () => {
      const vw = window.innerWidth;

      // console.log(this.currentlyDesktop);

      if (this.previousScreenWidth < this.sliderBreakpoint) {
        if (vw > this.sliderBreakpoint) {
          // console.log("breakpoint change");
          this.destroySwipers();
          this.initSwipersDesktop();
        }
      }

      if (this.previousScreenWidth > this.sliderBreakpoint) {
        if (vw < this.sliderBreakpoint) {
          // console.log("breakpoint change");
          this.destroySwipers();
          this.initSwipersMobile();
        }
      }

      this.previousScreenWidth = vw;
    });
    */
  }

  initSwipersDesktop() {
    // console.log("desktop");
    this.slidersArray.forEach((slider, index) => {
      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {
        slidesPerView: 1,
        spaceBetween: 30,
        speed: 600,
        parallax: true,
        autoplay: false,
        centeredSlides: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: 'fraction'
        },
      };
      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);
    });
  }

  initSwipersMobile() {
    // console.log("mobile");
    this.slidersArray.forEach((slider, index) => {
      const swiperContainer = slider.querySelector(
        this.sliderContainerSelector
      );
      let swiperConfig = {
        speed: 600,
        parallax: true,
        slidesPerView: 'auto',
        spaceBetween: 25,
        centeredSlides: false,
        pagination: {
          el: ".swiper-pagination",
          // dynamicBullets: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        on: {
          beforeInit: function(){
            let numOfSlides = swiperContainer.querySelectorAll(".swiper-slide").length;
            swiperContainer.querySelector('.total-slides').innerHTML = numOfSlides;
          },
          slideChange: function(){
            var currentSlide = this.realIndex + 1;
            console.log(currentSlide);
            swiperContainer.querySelector('.current-slide').innerHTML = currentSlide;
          }
        }
      };
      const instance = new Swiper(swiperContainer, swiperConfig);
      this.swiperInstances.push(instance);
    });
  }

  destroySwipers() {
    // console.log(this.swiperInstances);
    // console.log("destroy");
    this.swiperInstances.forEach((instance) => {
      instance.destroy(true, true);
    });
  }
}

export default SliderHandler;
